import { presetLoader } from './loader';
import { presetsTypes } from '../presets/presets-types';
export { presetLoader, presetsTypes };
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/fedops-presets/dist/es/src/index.js
// module id = 120
// module chunks = 0 1